import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

function TextToneSelect(props) {
  const { label, value, onChange, error } = props;
  let languageOptions = {
    'default':'Default',
    'direct':'Direct',
    'formal':'Formal',
    'neutral':'Neutral',
    'casual':'Casual',
    //'poem':'Make it a Poem',   
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel error={error}>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label} error={error} autoWidth>
      {Object.entries(languageOptions).map(([key, value]) => (
            <MenuItem key={key} value={key}>
                {value}
            </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

TextToneSelect.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
};

export default TextToneSelect;